class Vars {

    static PRODUCTEXPIRED() {
        return "PRODUCTEXPIRED"
    }

    static POSTER_DEFAULT_WIDTH() {
        return 324;
    }

    static POSTER_DEFAULT_HEIGHT() {
        return 576;
    }

    static TP_TITLE_MAX_LENGTH() {
        return 16;
    }

    static LINK_TEXT_LENGTH() {
        return 16;
    }

    static TP_KEYWORD_MAX_LENGTH() {
        return 10;
    }

    static ST_TITLE_MAX_LENGTH() {
        return 30;
    }

    static TTAG_MAX_LENGTH() {
        return 16;
    }

    static NICKNAME() {
        return 'NICKNAME'
    }

    // static GENDER(){
    //     return 'GENDER'
    // }
    // static DATE(){
    //     return 'DATE'
    // }

    static TEMP_MXD_ENTER() {
        return 'TEMP_MXD_ENTER';
    }

    static STOCKSURPLUS() {
        return 'STOCKSURPLUS'
    }

    //二阶库存剩余
    static STOCKSURPLUS2() {
        return 'STOCKSURPLUS2'
    }

    //三阶库存剩余
    static STOCKSURPLUS3() {
        return 'STOCKSURPLUS3'
    }

    static TIME() {
        return 'TIME'
    }

    static LINK() {
        return 'LINK'
    }

    static SPROGRAM() {
        return 'SPROGRAM'
    }

    static TOTAL_SUPPORT() {
        return 'TOTAL_SUPPORT'
    }

    static RANK() {
        return 'RANK'
    }

    static INVITATION_CODE() {
        return 'INVITATION_CODE'
    }

    static COMPLETED_TASK_NUM() {
        return 'COMPLETED_TASK_NUM'
    }

    static UNCOMPLETED_TASK_NUM() {
        return 'UNCOMPLETED_TASK_NUM'
    }

    static FORM_LINK_SELECT() {
        return 'FORM_LINK_SELECT'
    }

    static FORM_LINK() {
        return 'FORM_LINK'
    }

    static FORM_LINK2() {
        return 'FORM_LINK2'
    }

    static FORM_LINK3() {
        return 'FORM_LINK3'
    }

    static TIME() {
        return 'TIME'
    }

    static REDEEMCODE_NOTTP() {
        return 'REDEEMCODE_NOTTP';
    }

    static REDEEMCODE() {
        return 'REDEEMCODE';
    }

    static REDEEMCODE2() {
        return 'REDEEMCODE2';
    }

    static REDEEMCODE3() {
        return 'REDEEMCODE3';
    }

    static EMOJI() {
        return 'EMOJI';
    }

    static GOODS_NAME() {
        return 'GOODS_NAME';
    }

    static DATETIME() {
        return 'DATETIME';
    }

    static GOODS_AMOUNT() {
        return 'GOODS_AMOUNT';
    }

    static GROUP_NUM() {
        return 'GROUP_NUM';
    }

    static GROUP_LIMITEDTIME() {
        return 'GROUP_LIMITEDTIME';
    }

    static GROUP_ENDDATE() {
        return 'GROUP_ENDDATE';
    }

    static GROUP_BEGINDATE() {
        return 'GROUP_BEGINDATE';
    }

    static FROM_NICKNAME() {
        return 'FROM_NICKNAME';
    }


    static GROUP_PART_NUM() {
        return 'GROUP_PART_NUM';
    }

    static GROUP_CREATER() {
        return 'GROUP_CREATER';
    }

    static RETURN_AMOUNT() {
        return 'RETURN_AMOUNT';
    }

    static TALLIESDESC() {
        return 'TALLIESDESC';
    }

    static HELP_VERIFY_LINK() {
        return 'HELP_VERIFY_LINK';
    }

    static BOOST_NAME() {
        return 'GOODS_NAME';
    }

    static GIFTBAG_NAME() {
        return 'GIFTBAG_NAME';
    }

    /**
     * 企业微信账户姓名
     * @constructor
     */
    static WXW_ACCOUNT_NAME() {
        return "USERNAME"
    }

    /**
     * 添加时间
     * @returns {string}
     * @constructor
     */
    static ADD_TIME() {
        return "ADDTIME";
    }

    /**
     * 性别
     * @returns {string}
     * @constructor
     */
    static GENDER() {
        return "GENDER";
    }

    static GOODS_NAME_ITEM() {
        return '<span class="tpmsgend"></span><span id="GOODS_NAME" class="insertItem" contenteditable="false">商品名称</span><span class="tpmsgend"></span>';
    }

    static GIFTBAG_NAME_ITEM() {
        return '<span class="tpmsgend"></span><span id="GIFTBAG_NAME" class="insertItem" contenteditable="false">礼包名称</span><span class="tpmsgend"></span>';
    }

    static BOOST_NAME_ITEM() {
        return '<span class="tpmsgend"></span><span id="BOOST_NAME" class="insertItem" contenteditable="false">活动名称</span><span class="tpmsgend"></span>';
    }

    static NICKNAME_ITEM() {
        return '<span class="tpmsgend"></span><span id="NICKNAME" class="insertItem" contenteditable="false">昵称</span><span class="tpmsgend"></span>';
    }

    static INVITATION_CODE_ITEM() {
        return '<span class="tpmsgend"></span><span id="INVITATION_CODE" class="insertItem" contenteditable="false">邀请码</span><span class="tpmsgend"></span>';
    }

    static STOCKSURPLUS_ITEM() {
        return '<span class="tpmsgend"></span><span id="STOCKSURPLUS" class="insertItem" contenteditable="false">一阶任务库存剩余</span><span class="tpmsgend"></span>';
    }

    static STOCKSURPLUS_ITEM2() {
        return '<span class="tpmsgend"></span><span id="STOCKSURPLUS2" class="insertItem" contenteditable="false">二阶任务库存剩余</span><span class="tpmsgend"></span>';
    }

    static STOCKSURPLUS_ITEM3() {
        return '<span class="tpmsgend"></span><span id="STOCKSURPLUS3" class="insertItem" contenteditable="false">三阶任务库存剩余</span><span class="tpmsgend"></span>';
    }

    static TIME_ITEM() {
        return '<span class="tpmsgend"></span><span id="TIME" class="insertItem" contenteditable="false">时间</span><span class="tpmsgend"></span>';
    }

    static REDEEMCODE_ITEM() {
        return '<span class="tpmsgend"></span><span id="REDEEMCODE" class="insertItem" contenteditable="false">一阶任务兑换码</span><span class="tpmsgend"></span>';
    }

    static REDEEMCODE_ITEM2() {
        return '<span class="tpmsgend"></span><span id="REDEEMCODE2" class="insertItem" contenteditable="false">二阶任务兑换码</span><span class="tpmsgend"></span>';
    }

    static REDEEMCODE_ITEM3() {
        return '<span class="tpmsgend"></span><span id="REDEEMCODE3" class="insertItem" contenteditable="false">三阶任务兑换码</span><span class="tpmsgend"></span>';
    }

    static COMPLETED_TASK_NUM_ITEM() {
        return '<span classe="tpmsgend"></span><span id="COMPLETED_TASK_NUM" class="insertItem" contenteditable="false">已完成任务量</span><span class="tpmsgend"></span>';
    }

    static UNCOMPLETED_TASK_NUM_ITEM() {
        return '<span class="tpmsgend"></span><span id="UNCOMPLETED_TASK_NUM" class="insertItem" contenteditable="false">未完成任务量</span><span class="tpmsgend"></span>';
    }

    static TOTAL_SUPPORT_ITEM() {
        return '<span class="tpmsgend"></span><span id="TOTAL_SUPPORT" class="insertItem" contenteditable="false">累计获得支持人数</span><span class="tpmsgend"></span>';
    }


    static DATETIME_ITEM() {
        return '<span class="tpmsgend"></span><span id="DATETIME" class="insertItem" contenteditable="false">当前时间</span><span class="tpmsgend"></span>';
    }

    static GOODS_AMOUNT_ITEM() {
        return '<span class="tpmsgend"></span><span id="GOODS_AMOUNT" class="insertItem" contenteditable="false">商品价格</span><span class="tpmsgend"></span>';
    }

    static GROUP_NUM_ITEM() {
        return '<span class="tpmsgend"></span><span id="GROUP_NUM" class="insertItem" contenteditable="false">拼团人数</span><span class="tpmsgend"></span>';
    }

    static GROUP_LIMITEDTIME_ITEM() {
        return '<span class="tpmsgend"></span><span id="GROUP_LIMITEDTIME" class="insertItem" contenteditable="false">拼团限制时间</span><span class="tpmsgend"></span>';
    }

    static GROUP_ENDDATE_ITEM() {
        return '<span class="tpmsgend"></span><span id="GROUP_ENDDATE" class="insertItem" contenteditable="false">拼团截止时间</span><span class="tpmsgend"></span>';
    }

    static GROUP_BEGINDATE_ITEM() {
        return '<span class="tpmsgend"></span><span id="GROUP_BEGINDATE" class="insertItem" contenteditable="false">拼团开始时间</span><span class="tpmsgend"></span>';
    }

    static FROM_NICKNAME_ITEM() {
        return '<span class="tpmsgend"></span><span id="FROM_NICKNAME" class="insertItem" contenteditable="false">好友昵称</span><span class="tpmsgend"></span>';
    }

    static GROUP_PART_NUM_ITEM() {
        return '<span class="tpmsgend"></span><span id="GROUP_PART_NUM" class="insertItem" contenteditable="false">已参团人数</span><span class="tpmsgend"></span>';
    }

    static GROUP_CREATER_ITEM() {
        return '<span class="tpmsgend"></span><span id="GROUP_CREATER" class="insertItem" contenteditable="false">团长昵称</span><span class="tpmsgend"></span>';
    }

    static RETURN_AMOUNT_ITEM() {
        return '<span class="tpmsgend"></span><span id="RETURN_AMOUNT" class="insertItem" contenteditable="false">返现金额</span><span class="tpmsgend"></span>';
    }

    static TALLIESDESC_ITEM() {
        return '<span class="tpmsgend"></span><span id="TALLIESDESC" class="insertItem" contenteditable="false">奖励金入账说明</span><span class="tpmsgend"></span>';
    }

    static WXW_ACCOUNT_NAME_ITEM() {
        return '<span class="tpmsgend"></span><span id="WXW_ACCOUNT_NAME" class="insertItem" contenteditable="false">账号姓名</span><span class="tpmsgend"></span>';
    }

    static ADD_TIME_ITEM() {
        return '<span class="tpmsgend"></span><span id="ADD_TIME" class="insertItem" contenteditable="false">添加时间</span><span class="tpmsgend"></span>';
    }

    static GENDER_ITEM() {
        return '<span class="tpmsgend"></span><span id="GENDER" class="insertItem" contenteditable="false">性别</span><span class="tpmsgend"></span>';
    }

    static INSERT_ITEM_ID_MAP() {
        return {
            NICKNAME: true,
            LINK: true,
            TOTAL_SUPPORT: true,
            COMPLETED_TASK_NUM: true,
            UNCOMPLETED_TASK_NUM: true,
            RANK: true,
            STOCKSURPLUS: true,
            INVITATION_CODE: true,
            BOOST_NAME: true,
        };
    }

    static getChartDefaultColors() {
        return ['rgba(91, 143, 249, 1)', 'rgba(90, 216, 166, 1)', 'rgba(93, 112, 146, 1)', 'rgba(246, 189, 22, 1)', '#8E8AFF']
    }

    /**
     * 商品头图图片大小 bit
     * @returns {number}
     * @constructor
     */
    static GOODS_COVER_IMAGE_MAXSIZE() {
        return 500 * 1024;
    }

    static SHARE_COVER_IMAGE_MAXSIZE() {
        return 625 * 1024;
    }

    /**
     * 客服图片大小 bit
     * @returns {number}
     * @constructor
     */
    static CUSTOMER_IMAGE_MAXSIZE() {
        return 200 * 1024;
    }

    /**
     * 海报图片大小 bit
     * @returns {number}
     * @constructor
     */
    static POSTER_IMAGE_MAXSIZE() {
        return 1024 * 1024;
    }

    /**
     * 默认图片大小 bit
     * @returns {number}
     * @constructor
     */
    static DEFAULT_IMAGE_MAXSIZE() {
        return 2 * 1024 * 1024;
    }

    /**
     * 文件默认大小
     * @returns {number}
     * @constructor
     */
    static FILE_MAXSIZE() {
        return 50 * 1024 * 1024;
    }

    /**
     * 视频默认大小
     * @returns {number}
     * @constructor
     */
    static VIDEO_MAXSIZE() {
        return 50 * 1024 * 1024;
    }

    /**
     * 音频默认大小 bit
     * @constructor
     */
    static AUDIO_MAXSIZE() {
        return 50 * 1024 * 1024;
    }

    /**
     * 音频默认长度 分钟
     * @constructor
     */
    static AUDIO_MAXLENGTH() {
        return 60;
    }

    // 产品代码编号
    static PRO_NUMBER() {
        return {
            MSG: 8000,//消息宝
            TASKPOSTER: 8006,//任务宝
            SHARE: 8010,//分享宝
            CHANNEL: 8012,//渠道码
            LIVECODE: 8014,//活码
            GROUPBUY: 9010,//拼团
            RETAIL: 9000,//分销
            FESTIVALSIGN: 8016,//节日签
        }
    }

    static PRO_NAME() {
        return {
            [this.PRO_NUMBER().MSG]: '消息宝',//消息宝
            [this.PRO_NUMBER().TASKPOSTER]: '任务宝',//任务宝
            [this.PRO_NUMBER().SHARE]: '分享宝',//分享宝
            [this.PRO_NUMBER().CHANNEL]: '渠道码',//渠道码
            [this.PRO_NUMBER().LIVECODE]: '活码系统',//活码
            [this.PRO_NUMBER().GROUPBUY]: '拼团系统',//拼团
            [this.PRO_NUMBER().RETAIL]: '分销系统',//分销
            [this.PRO_NUMBER().FESTIVALSIGN]: '节日签'//分销
        }
    }


    // 表单

    static formType() {
        return {
            input: {
                type: "cmpt_input",
                text: "单行文本",
                key: "input"
            },
            textarea: {
                type: "cmpt_textarea",
                text: "多行文本",
                key: "textarea"
            },
            num: {
                type: "cmpt_num",
                text: "数字",
                key: "num"
            },
            radio: {
                type: "cmpt_radio",
                text: "单选",
                key: "radio"
            },
            checkbox: {
                type: "cmpt_checkbox",
                text: "多选",
                key: "checkbox"
            },
            select: {
                type: "cmpt_select",
                text: "下拉框",
                key: "select"
            },
            date: {
                type: "cmpt_date",
                text: "日期时间",
                key: "date"
            },
            image: {
                type: "cmpt_image",
                text: "图片展示",
                key: "image"
            },
            address: {
                type: "cmpt_address",
                text: "地址",
                key: "address"
            },
            score: {
                type: "cmpt_score",
                text: "评分",
                key: "score"
            },
            edit: {
                type: "cmpt_edit",
                text: "文本描述",
                key: "edit"
            },
            name: {
                type: "cmpt_name",
                text: "姓名",
                key: "name"
            },
            phoneno: {
                type: "cmpt_phoneno",
                text: "手机号",
                key: "phoneno"
            },
            email: {
                type: "cmpt_email",
                text: "邮箱",
                key: "email"
            },
            gongsi: {
                type: "cmpt_gongsi",
                text: "公司",
                key: "gongsi"
            },
            bumen: {
                type: "cmpt_bumen",
                text: "部门",
                key: "bumen"
            },
            zhiwei: {
                type: "cmpt_zhiwei",
                text: "职位",
                key: "zhiwei"
            },
            chengwei: {
                type: "cmpt_chengwei",
                text: "称谓",
                key: "chengwei"
            },
            sex: {
                type: "cmpt_sex",
                text: "性别",
                key: "sex"
            },
            birthday: {
                type: "cmpt_birthday",
                text: "生日",
                key: "birthday"
            },
            remark: {
                type: "cmpt_remark",
                text: "备注",
                key: "remark"
            },
            youbian: {
                type: "cmpt_youbian",
                text: "邮编",
                key: "youbian"
            },
            idcard: {
                type: "cmpt_idcard",
                text: "身份证号",
                key: "idcard"
            },
            weixin: {
                type: "cmpt_weixin",
                text: "微信",
                key: "weixin"
            },
            qq: {
                type: "cmpt_qq",
                text: "QQ",
                key: "qq"
            },
            weibo: {
                type: "cmpt_weibo",
                text: "微博",
                key: "weibo"
            },
            citypicker: {
                type: "cmpt_citypicker",
                text: "地址",
                key: "phoneno"
            },
            textareaOld: {
                type: "textarea",
                text: "标题"
            },
            btn: {
                type: "cmpt_btnword",
                text: "提交"
            },
        }
    }

    static formTypeArr() {
        return ["input", "textarea", "num", "radio", "checkbox", "select", "date", "edit", "score", "image", "address"]
    }

    static formTypeNewArr() {
        return ["name", "phoneno", "email", "gongsi", "bumen", "zhiwei", "chengwei", "sex", "birthday",
            "remark", "youbian", "idcard", "weixin", "qq", "weibo"]
    }

    static formTypeNew() {
        return ["cmpt_name", "cmpt_phoneno", "cmpt_email", "cmpt_gongsi", "cmpt_bumen", "cmpt_zhiwei", "cmpt_chengwei", "cmpt_sex", "cmpt_birthday",
            "cmpt_remark", "cmpt_youbian", "cmpt_idcard", "cmpt_weixin", "cmpt_qq", "cmpt_weibo"]
    }

    static bgColorArr() {
        return ["#EDEDED", "#FFA39E", "#FFBB96", "#FFD591", "#FFE58F", "#B7EB8F", "#87E8DE",
            "#91D5FF", "#ADC6FF", "#D3ADF7", "#FFADD2", "#E9E9E9", "#D1C4E9"]
    }

    /**
     * 分销佣金到账提醒变量
     * @returns {string[]}
     */
    static getDistriNotifyVars() {
        return [
            Vars.GOODS_NAME(),
            Vars.GOODS_AMOUNT(),
            Vars.RETURN_AMOUNT(),
            Vars.NICKNAME(),
            Vars.FROM_NICKNAME(),
            Vars.TALLIESDESC(),
            Vars.DATETIME(),
        ];
    }

    /**
     * 开团成功通知变量
     * @returns {string[]}
     */
    static getGroupbuyCreateNotifyVars() {
        return [
            Vars.GOODS_NAME(),
            Vars.GOODS_AMOUNT(),
            Vars.GROUP_NUM(),
            Vars.GROUP_ENDDATE(),
            Vars.GROUP_CREATER(),
        ];
    }

    /**
     * 好友参团通知变量
     * @returns {string[]}
     */
    static getFriendPartGroupbuyNotifyVars() {
        return [
            Vars.GOODS_NAME(),
            Vars.DATETIME(),
            Vars.GOODS_AMOUNT(),
            Vars.GROUP_NUM(),
            Vars.GROUP_ENDDATE(),
            Vars.FROM_NICKNAME(),
            Vars.GROUP_PART_NUM(),
        ];
    }

    /**
     * 自己参团通知变量
     */
    static getPartGroupbuyNotifyVars() {
        return [
            Vars.GOODS_NAME(),
            Vars.DATETIME(),
            Vars.GOODS_AMOUNT(),
            Vars.GROUP_NUM(),
            Vars.GROUP_ENDDATE(),
            Vars.GROUP_PART_NUM(),
            Vars.GROUP_CREATER(),
        ];
    }

    /**
     * 拼团成功通知变量
     * @returns {string[]}
     */
    static getGroupbuySuccessNotifyVars() {
        return [
            Vars.GOODS_NAME(),
            Vars.DATETIME(),
            Vars.GOODS_AMOUNT(),
            Vars.GROUP_NUM(),
            Vars.GROUP_CREATER(),
        ];
    }

    /**
     * 拼团失败通知变量
     * @returns {string[]}
     */
    static getGroupbuyFailNotifyVars() {
        return [
            Vars.GOODS_NAME(),
            Vars.DATETIME(),
            Vars.GOODS_AMOUNT(),
            Vars.GROUP_NUM(),
            Vars.GROUP_ENDDATE(),
            Vars.GROUP_BEGINDATE(),
            Vars.GROUP_CREATER(),
        ]
    }
}

export default Vars